var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.722 8.61H5.157l2.621-3.149a.723.723 0 10-1.112-.924L3.055 8.87a.858.858 0 00-.065.109c0 .036 0 .057-.05.094a.722.722 0 00-.051.26c0 .089.018.177.05.26 0 .036 0 .057.051.093a.86.86 0 00.065.109l3.611 4.333a.723.723 0 001.112-.924l-2.621-3.15h8.565a.722.722 0 100-1.444z"
  })));
}
export default SvgArrowLeftIcon;